"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var vue_1 = require("vue");
var vue_2 = require("vue");
var _withScopeId = function (n) { return ((0, vue_2.pushScopeId)("data-v-5feecb45"), n = n(), (0, vue_2.popScopeId)(), n); };
var _hoisted_1 = {
    key: 0,
    class: "home-layout"
};
var vue_3 = require("vue");
var element_plus_1 = require("element-plus");
var home_1 = require("@/apis/home");
var AuthorCharts_vue_1 = __importDefault(require("@/components/Echarts/AuthorCharts.vue"));
var PieCharts_vue_1 = __importDefault(require("@/components/Echarts/PieCharts.vue"));
var DynastyCharts_vue_1 = __importDefault(require("@/components/Echarts/DynastyCharts.vue"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'HomeView',
    setup: function (__props) {
        var _this = this;
        var dynastyCountData = (0, vue_3.ref)({
            countData: [],
            category: [],
        });
        var authorCountData = (0, vue_3.ref)({
            countData: [],
            category: [],
        });
        var authorByDynastyCountData = (0, vue_3.ref)({
            countData: [],
            category: [],
        });
        var getEchartsData = function () { return __awaiter(_this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, (0, home_1.getPoetryCountTotal)()];
                    case 1:
                        data = (_a.sent()).data;
                        data.dynasty_poems.forEach(function (element) {
                            dynastyCountData.value.countData.push(element.poem_count);
                            dynastyCountData.value.category.push(element.dynasty);
                        });
                        data.author_poems.forEach(function (element) {
                            authorCountData.value.countData.push({ name: element.author, value: element.poem_count });
                            authorCountData.value.category.push(element.author);
                        });
                        data.poet_count_author_by_dynasty.forEach(function (element) {
                            authorByDynastyCountData.value.category.push(element.dynasty);
                            authorByDynastyCountData.value.countData.push(element.author_count);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        var timer = null;
        var previousHeight = 0;
        var isReload = (0, vue_3.ref)(true);
        var loadingInstance = null;
        var onResize = function () {
            var currentHeight = window.innerHeight;
            if (timer || currentHeight === previousHeight)
                return;
            timer = setTimeout(function () {
                isReload.value = false;
                loadingInstance = element_plus_1.ElLoading.service({
                    lock: true,
                    text: '系统视图切换中，请稍候...',
                    background: 'rgba(0, 0, 0, 0.5)',
                });
                var fullScreenTimer = null;
                fullScreenTimer = setTimeout(function () {
                    previousHeight = currentHeight;
                    isReload.value = true;
                    if (loadingInstance) {
                        loadingInstance.close();
                    }
                    if (fullScreenTimer) {
                        clearTimeout(fullScreenTimer);
                    }
                }, 1000);
                if (timer) {
                    clearTimeout(timer);
                    timer = null;
                }
            }, 500);
        };
        window.addEventListener("resize", onResize);
        (0, vue_3.onUnmounted)(function () {
            window.removeEventListener("resize", onResize);
        });
        getEchartsData();
        return function (_ctx, _cache) {
            var _component_el_empty = (0, vue_2.resolveComponent)("el-empty");
            var _component_el_col = (0, vue_2.resolveComponent)("el-col");
            var _component_el_row = (0, vue_2.resolveComponent)("el-row");
            return ((0, vue_2.unref)(isReload))
                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                    (0, vue_2.createVNode)(_component_el_row, { class: "echart-box" }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createVNode)(_component_el_col, { span: 24 }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    ((0, vue_2.unref)(dynastyCountData).category.length > 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(DynastyCharts_vue_1.default, {
                                            key: 0,
                                            countData: (0, vue_2.unref)(dynastyCountData).countData,
                                            category: (0, vue_2.unref)(dynastyCountData).category
                                        }, null, 8, ["countData", "category"]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_empty, {
                                            key: 1,
                                            description: "图表数据为空"
                                        }))
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    }),
                    (0, vue_2.createVNode)(_component_el_row, { class: "echart-box" }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createVNode)(_component_el_col, { span: 24 }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    ((0, vue_2.unref)(authorByDynastyCountData).category.length > 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(AuthorCharts_vue_1.default, {
                                            key: 0,
                                            category: (0, vue_2.unref)(authorByDynastyCountData).category,
                                            countData: (0, vue_2.unref)(authorByDynastyCountData).countData
                                        }, null, 8, ["category", "countData"]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_empty, {
                                            key: 1,
                                            description: "图表数据为空"
                                        }))
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    }),
                    (0, vue_2.createVNode)(_component_el_row, {
                        class: "echart-box scroll-bar",
                        style: { "overflow-y": "auto" }
                    }, {
                        default: (0, vue_2.withCtx)(function () { return [
                            (0, vue_2.createVNode)(_component_el_col, { span: 24 }, {
                                default: (0, vue_2.withCtx)(function () { return [
                                    ((0, vue_2.unref)(authorCountData).category.length > 0)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(PieCharts_vue_1.default, {
                                            key: 0,
                                            countData: (0, vue_2.unref)(authorCountData).countData,
                                            category: (0, vue_2.unref)(authorCountData).category
                                        }, null, 8, ["countData", "category"]))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_el_empty, {
                                            key: 1,
                                            description: "图表数据为空"
                                        }))
                                ]; }),
                                _: 1
                            })
                        ]; }),
                        _: 1
                    })
                ]))
                : (0, vue_2.createCommentVNode)("", true);
        };
    }
});
